import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { FEATURES } from "./planConfig";

export default function FreePlanCard({ isAnnual, isPaid }) {
  return (
    <Card className="p-8 rounded-2xl border-border" data-testid="plan-free">
      <div className="text-sm font-medium text-stone-500 uppercase tracking-widest">Free</div>
      <div className="mt-2 flex items-baseline gap-1">
        <span className="font-display text-5xl">$0</span>
        <span className="text-stone-500">/{isAnnual ? "year" : "month"}</span>
      </div>
      <p className="text-sm text-stone-500 mt-2">Perfect for a single upcoming trip.</p>
      <ul className="mt-6 space-y-2 text-sm">
        {FEATURES.free.map((f) => (
          <li key={f} className="flex items-start gap-2">
            <Check className="w-4 h-4 text-primary mt-0.5 shrink-0" /> {f}
          </li>
        ))}
      </ul>
      {!isPaid && (
        <Button variant="outline" disabled className="w-full mt-6 rounded-full" data-testid="current-free-btn">
          Current plan
        </Button>
      )}
    </Card>
  );
}
